import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import ReactModal from 'react-modal';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import {Wrapper} from 'system/wrapper';
import {TimeList, TimeItem, DetailList} from './components';
import Breadcrumbs from '../../breadcrumbs';
import {ButtonWrap, LinkDefault, ButtonDefault} from 'components/buttons';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {Label, Divider, Tip} from 'components/common';
import {submitRecord, changeDate, loadReceptionByDate} from 'redux/actions/portal/records';
import {loadInstitutionPersonalDetail} from 'redux/actions/portal/institutions';

import close from 'images/general/close.svg';

const mapStateToProps = state => ({
  receptions: state.records.get('reception'),
  currentRecord: state.records.get('currentRecord'),
  user: state.auth.get('user'),
  isSubmiting: state.records.get('isLoading'),
  date: state.records.get('date'),
  doctor: state.institutions.get('institutionPersonalDetail')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (date, id) => {
    dispatch(loadReceptionByDate(date, id))
    dispatch(loadInstitutionPersonalDetail(id))
  },
  onSubmit: (reception, user) => dispatch(submitRecord(reception, user)),
  onChangeDate: (date, id) => {
    dispatch(changeDate(date))
    dispatch(loadReceptionByDate(date, id))
  }
});

class DoctorRecord extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      time: null,
      time_start: null,
      time_end: null,
      date: null,
      step1: true,
      step2: false
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openStep1 = this.openStep1.bind(this);
    this.openStep2 = this.openStep2.bind(this);
  }

  toggleModal(time_id, time_start, time_end, date) {
    this.setState({
      modalOpen: !this.state.modalOpen,
      time: time_id,
      time_start: time_start,
      time_end: time_end,
      date: date
    });
  }

  closeModal() {
    this.setState({
      modalOpen: false
    })
  }

  openStep1() {
    this.setState({
      step1: true,
      step2: false
    })
  }

  openStep2() {
    this.setState({
      step1: false,
      step2: true
    })
  }

  componentWillMount() {
    this.props.onLoad(this.props.date, this.props.match.params.doctor);
  }

  render() {

    if (this.props.receptions === undefined || this.props.doctor === undefined) {
      return null;
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/institutions">Установи</Link></li>
          <li><Link to={`/institutions/detail/${this.props.doctor.get('institution_data').get('id')}`}>{this.props.doctor.get('institution_data').get('short_title')}</Link></li>
          <li><Link to={`/institutions/detail/${this.props.doctor.get('institution_data').get('id')}/personal/${this.props.doctor.get('id')}`}>{this.props.doctor.get('user_data').get('last_name')} {this.props.doctor.get('user_data').get('first_name')}</Link></li>
          <li><Link to={`/institutions/detail/${this.props.doctor.get('institution_data').get('id')}/personal/${this.props.doctor.get('id')}/record`}>Запис на прийом</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Запис до лікаря</h2>
            <Divider>
              <DetailList>
                <li>ПІБ лікаря: <span>{this.props.doctor.get('user_data').get('last_name')} {this.props.doctor.get('user_data').get('first_name')} {this.props.doctor.get('user_data').get('middle_name')}</span></li>
                <li>Посада: <span>{this.props.doctor.get('position_title')}</span></li>
                <li>Номер кабінета: <span>{this.props.doctor.get('cabinet_number')}</span></li>
                <li>Телефон: <span>{this.props.doctor.get('phone')}</span></li>
                <li>Медичний заклад: <span>{this.props.doctor.get('institution_data').get('full_title')}</span></li>
                <li>Адреса: <span>{this.props.doctor.get('institution_data').get('address')}</span></li>
              </DetailList>
            </Divider>
            <Divider>
              <Label>Виберіть дату запису:</Label>
              <DatePicker
                locale="uk-UA"
                selected={this.props.date}
                dateFormat="YYYY-MM-DD"
                onChange={(date) => this.props.onChangeDate(date, this.props.match.params.doctor)}
                minDate={moment()}
              />
            </Divider>
            <Divider>
            {this.props.receptions.size > 0 ? (
              <div>
                <Label>Виберіть час запису:</Label>
                <TimeList>
                  {this.props.receptions.map((item, i) => (
                    <TimeItem open={item.get('is_available')} onClick={() => {
                      item.get('is_available')
                      ? this.toggleModal(item.get('id'), item.get('start_time'), item.get('end_time'), item.get('start_date'))
                      : null
                    }}>{new Date('2018-01-01T' + item.get('start_time')).toLocaleTimeString('uk-UA', {hour: '2-digit', minute:'2-digit'})} - {new Date('2018-01-01T' + item.get('end_time')).toLocaleTimeString('uk-UA', {hour: '2-digit', minute:'2-digit'})}</TimeItem>
                  ))}
                </TimeList>
              </div>
            ):(
              <Tip>В цей день лікар не приймає</Tip>
            )}
          </Divider>
          </Grid>
        </Wrapper>


        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div  onClick={(event) => this.toggleModal()}>
				         <img src={close} alt="закрити" />
              </div>
						</CloseModal>
            {this.state.step1 &&
            <ModalContent>
              <h3>Ви підтверджуєте запис до лікаря {this.props.doctor.get('user_data').get('last_name')} {this.props.doctor.get('user_data').get('first_name')} {this.props.doctor.get('user_data').get('middle_name')} на {this.state.date}, {new Date('2018-01-01T' + this.state.time_start).toLocaleTimeString('uk-UA', {hour: '2-digit', minute:'2-digit'})} ?</h3>
              <ButtonWrap>
                <ButtonDefault disabled={this.props.isSubmiting} value="Підтвердити" onClick={() => {
                  this.props.onSubmit(this.state.time, this.props.user.get('id'))
                  this.openStep2()
                }} />
                <ButtonDefault onClick={(event) => this.toggleModal()} value="Скасувати" />
              </ButtonWrap>
            </ModalContent>
            }

            {this.state.step2 &&
              <ModalContent>
                <h3>Дякуємо, ваш запис до лікаря успішно створений!</h3>
                <Divider>
                  <h3>Слідкувати за станом вашого запису ви можете за цим <Link style={{color: "#edbd2f"}} to={this.props.currentRecord === undefined ? `/`:  `/cabinet/records/detail/${this.props.currentRecord.get('id')}`}>посиланням</Link></h3>
                </Divider>
                <ButtonWrap>
                  <ButtonDefault value="До порталу" onClick={() => {
                    this.closeModal()
                    this.openStep1()
                    this.props.onLoad(this.props.date, this.props.match.params.doctor);
                  }}/>
                  <LinkDefault to={`/cabinet/records/detail/${this.props.currentRecord === undefined ? "/" : this.props.currentRecord.get('id')}`}>До запису</LinkDefault>
                </ButtonWrap>
              </ModalContent>
            }

          </Modal>

        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DoctorRecord);



// WEBPACK FOOTER //
// ./src/system/main/institutions/record.js